module.exports = __webpack_public_path__ + "img/public-bg.ea90101b.jpg";